// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".travianServerSelector{display:grid;grid-template-columns:1fr 1fr}\n", "",{"version":3,"sources":["webpack://./jsm/travian/Container/TravianServerSelector/TravianServerSelector.sass"],"names":[],"mappings":"AAAA,uBACI,YAAa,CACb,6BAA8B","sourcesContent":[".travianServerSelector {\n    display: grid;\n    grid-template-columns: 1fr 1fr; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
